export default __webpack_public_path__ + "97b67239e4f0603bcba5efe7950e6efe.svg";